import { render, staticRenderFns } from "./ParamEdit.vue?vue&type=template&id=c0761e2c&scoped=true&"
import script from "./ParamEdit.vue?vue&type=script&lang=js&"
export * from "./ParamEdit.vue?vue&type=script&lang=js&"
import style0 from "./ParamEdit.vue?vue&type=style&index=0&id=c0761e2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0761e2c",
  null
  
)

export default component.exports